(function () {
  'use strict';

  /*
   * ============================================
   * POMCHA FREE GIFT - ALL PRODUCTS
   * ============================================
   *
   * Rule:
   * Any product can qualify.
   *
   * If normal cart value >= ₹15,000
   * → add earrings as free gift.
   *
   * If normal cart value < ₹15,000
   * → remove automatic gift.
   *
   * Gift quantity is always 1.
   * ============================================
   */

  if (window.__pomchaFreeGiftV6Loaded) {
    return;
  }

  window.__pomchaFreeGiftV6Loaded = true;

  var CONFIG = {

    /*
     * ₹15,000
     */
    threshold: 1500000,

    /*
     * Gift product handle
     */
    giftHandle: 'earrings',

    /*
     * Property used to identify our automatic gift
     */
    giftPropertyKey: '_free_rakshabandhan_gift',

    giftPropertyValue: 'true',

    /*
     * Unique cache key
     */
    giftCacheKey:
      'pomcha_free_gift_earrings_v6',

    cacheTTL:
      10 * 60 * 1000,

    syncDelay: 200

  };


  var state = {

    giftVariantId: null,

    giftProductId: null,

    giftPromise: null,

    syncTimer: null,

    syncRunning: false,

    syncAgain: false

  };


  /*
   * ============================================
   * ROOT URL
   * ============================================
   */

  function rootUrl(path) {

    var root =
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
        ? Shopify.routes.root
        : '/';

    return (
      root +
      path.replace(/^\/+/, '')
    );

  }


  /*
   * ============================================
   * JSON FETCH
   * ============================================
   */

  async function fetchJson(
    url,
    options
  ) {

    var response =
      await fetch(
        url,
        options || {}
      );

    var text =
      await response.text();

    var data;

    try {

      data =
        JSON.parse(text);

    } catch (e) {

      throw new Error(
        'Invalid Shopify response: ' +
        text.substring(0, 200)
      );

    }


    if (!response.ok) {

      throw new Error(
        data.description ||
        data.message ||
        'Shopify request failed'
      );

    }

    return data;

  }


  /*
   * ============================================
   * STORAGE
   * ============================================
   */

  function readStorage(key) {

    try {

      return JSON.parse(
        localStorage.getItem(key)
      );

    } catch (e) {

      return null;

    }

  }


  function writeStorage(
    key,
    value
  ) {

    try {

      localStorage.setItem(
        key,
        JSON.stringify(value)
      );

    } catch (e) {}

  }


  /*
   * ============================================
   * CHECK FREE GIFT
   * ============================================
   */

  function isGiftItem(item) {

    if (!item) {
      return false;
    }

    if (!item.properties) {
      return false;
    }

    return (
      String(
        item.properties[
          CONFIG.giftPropertyKey
        ]
      ) ===
      CONFIG.giftPropertyValue
    );

  }


  /*
   * ============================================
   * GET GIFT ITEMS
   * ============================================
   */

  function getGiftItems(cart) {

    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {

      return [];

    }

    return cart.items.filter(
      function (item) {

        return isGiftItem(item);

      }
    );

  }


  /*
   * ============================================
   * GET CART
   * ============================================
   */

  async function getCart() {

    return fetchJson(
      rootUrl('cart.js') +
      '?_=' +
      Date.now()
    );

  }


  /*
   * ============================================
   * LOAD EARRINGS VARIANT
   * ============================================
   */

  async function loadGiftVariant(
    forceRefresh
  ) {

    if (
      !forceRefresh &&
      state.giftVariantId
    ) {

      return state.giftVariantId;

    }


    if (
      !forceRefresh &&
      state.giftPromise
    ) {

      return state.giftPromise;

    }


    state.giftPromise =
      (async function () {

        /*
         * Try cache
         */
        if (!forceRefresh) {

          var cached =
            readStorage(
              CONFIG.giftCacheKey
            );

          if (
            cached &&
            cached.variantId &&
            cached.timestamp &&
            (
              Date.now() -
              cached.timestamp
            ) <
              CONFIG.cacheTTL
          ) {

            state.giftVariantId =
              Number(
                cached.variantId
              );

            state.giftProductId =
              cached.productId
                ? Number(
                    cached.productId
                  )
                : null;

            return state.giftVariantId;

          }

        }


        console.log(
          '[Pomcha Free Gift] Loading gift product:',
          CONFIG.giftHandle
        );


        /*
         * Get product
         */
        var product =
          await fetchJson(
            rootUrl(
              'products/' +
              CONFIG.giftHandle +
              '.js'
            )
          );


        if (
          !product ||
          !product.id
        ) {

          throw new Error(
            'Gift product not found: ' +
            CONFIG.giftHandle
          );

        }


        var variants =
          Array.isArray(
            product.variants
          )
            ? product.variants
            : [];


        if (!variants.length) {

          throw new Error(
            'Gift product has no variants.'
          );

        }


        /*
         * Find available variant
         */
        var variant =
          variants.find(
            function (item) {

              return (
                item.available !== false
              );

            }
          );


        /*
         * If availability is not returned,
         * use first variant.
         */
        if (!variant) {

          variant =
            variants[0];

        }


        state.giftVariantId =
          Number(
            variant.id
          );

        state.giftProductId =
          Number(
            product.id
          );


        writeStorage(
          CONFIG.giftCacheKey,
          {

            timestamp:
              Date.now(),

            variantId:
              state.giftVariantId,

            productId:
              state.giftProductId

          }
        );


        console.log(
          '[Pomcha Free Gift] Gift variant:',
          state.giftVariantId
        );


        return state.giftVariantId;

      })();


    try {

      return await state.giftPromise;

    } finally {

      state.giftPromise = null;

    }

  }


  /*
   * ============================================
   * CALCULATE QUALIFYING CART VALUE
   * ============================================
   *
   * IMPORTANT:
   *
   * Every product counts.
   *
   * Collection is NOT checked.
   *
   * Automatic gift itself is excluded.
   *
   * final_line_price is used first because
   * it represents the actual discounted line price.
   *
   * ============================================
   */

  function getQualifyingCartValue(
    cart
  ) {

    if (
      !cart ||
      !Array.isArray(cart.items)
    ) {

      return 0;

    }


    var total = 0;


    cart.items.forEach(
      function (item) {

        /*
         * Do not count our free gift.
         */
        if (
          isGiftItem(item)
        ) {

          return;

        }


        /*
         * Actual selling price after
         * line-level discounts.
         */
        var linePrice =
          Number(
            item.final_line_price
          );


        /*
         * Fallback
         */
        if (
          !Number.isFinite(
            linePrice
          )
        ) {

          linePrice =
            Number(
              item.line_price || 0
            );

        }


        total += linePrice;

      }
    );


    return total;

  }


  /*
   * ============================================
   * QUALIFICATION
   * ============================================
   */

  function qualifiesForGift(
    cart
  ) {

    var total =
      getQualifyingCartValue(
        cart
      );


    console.log(
      '[Pomcha Free Gift] Qualifying cart value: ₹' +
      (
        total / 100
      ).toFixed(2)
    );


    return (
      total >=
      CONFIG.threshold
    );

  }


  /*
   * ============================================
   * REFRESH CART UI
   * ============================================
   */

  function refreshCartUI() {

    try {

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true
          }
        )
      );

    } catch (e) {}


    try {

      document.documentElement.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true
          }
        )
      );

    } catch (e) {}

  }


  /*
   * ============================================
   * ADD GIFT
   * ============================================
   */

  async function addGift() {

    var variantId =
      await loadGiftVariant(
        false
      );


    /*
     * Check again immediately
     * before adding.
     */
    var cart =
      await getCart();


    var existingGifts =
      getGiftItems(cart);


    if (
      existingGifts.length
    ) {

      console.log(
        '[Pomcha Free Gift] Gift already exists.'
      );

      return;

    }


    console.log(
      '[Pomcha Free Gift] Adding free gift...'
    );


    await fetchJson(
      rootUrl(
        'cart/add.js'
      ),
      {

        method: 'POST',

        headers: {

          'Content-Type':
            'application/json',

          'X-Requested-With':
            'XMLHttpRequest'

        },

        body:
          JSON.stringify({

            items: [

              {

                id:
                  variantId,

                quantity:
                  1,

                properties: {

                  [CONFIG.giftPropertyKey]:
                    CONFIG.giftPropertyValue

                }

              }

            ]

          })

      }
    );


    console.log(
      '[Pomcha Free Gift] Gift added successfully.'
    );


    refreshCartUI();

  }


  /*
   * ============================================
   * REMOVE GIFT
   * ============================================
   */

  async function removeGift(
    item
  ) {

    if (!item) {
      return;
    }


    console.log(
      '[Pomcha Free Gift] Removing gift:',
      item.key
    );


    await fetchJson(
      rootUrl(
        'cart/change.js'
      ),
      {

        method: 'POST',

        headers: {

          'Content-Type':
            'application/json',

          'X-Requested-With':
            'XMLHttpRequest'

        },

        body:
          JSON.stringify({

            id:
              item.key,

            quantity:
              0

          })

      }
    );


    refreshCartUI();

  }


  /*
   * ============================================
   * REMOVE ALL GIFTS
   * ============================================
   */

  async function removeAllGifts(
    cart
  ) {

    var gifts =
      getGiftItems(cart);


    if (!gifts.length) {
      return;
    }


    for (
      var i = 0;
      i < gifts.length;
      i++
    ) {

      await removeGift(
        gifts[i]
      );

    }

  }


  /*
   * ============================================
   * FORCE QUANTITY = 1
   * ============================================
   */

  async function setGiftQuantityOne(
    item
  ) {

    if (!item) {
      return;
    }


    if (
      Number(item.quantity) ===
      1
    ) {

      return;

    }


    await fetchJson(
      rootUrl(
        'cart/change.js'
      ),
      {

        method: 'POST',

        headers: {

          'Content-Type':
            'application/json',

          'X-Requested-With':
            'XMLHttpRequest'

        },

        body:
          JSON.stringify({

            id:
              item.key,

            quantity:
              1

          })

      }
    );


    refreshCartUI();

  }


  /*
   * ============================================
   * MAIN SYNC
   * ============================================
   */

  async function syncGift() {

    var cart =
      await getCart();


    var cartValue =
      getQualifyingCartValue(
        cart
      );


    var qualifies =
      cartValue >=
      CONFIG.threshold;


    var gifts =
      getGiftItems(cart);


    console.log(
      '[Pomcha Free Gift]',
      {
        cartValue:
          '₹' +
          (
            cartValue /
            100
          ).toFixed(2),

        threshold:
          '₹15,000',

        qualifies:
          qualifies,

        giftCount:
          gifts.length
      }
    );


    /*
     * =========================================
     * BELOW ₹15,000
     * =========================================
     */

    if (!qualifies) {

      if (gifts.length) {

        await removeAllGifts(
          cart
        );

      }

      return;

    }


    /*
     * =========================================
     * ₹15,000+
     * =========================================
     */

    if (!gifts.length) {

      await addGift();

      return;

    }


    /*
     * Keep only ONE gift.
     */
    var firstGift =
      gifts[0];


    /*
     * Force quantity to 1.
     */
    if (
      Number(
        firstGift.quantity
      ) !== 1
    ) {

      await setGiftQuantityOne(
        firstGift
      );

    }


    /*
     * Remove duplicate gift lines.
     */
    if (
      gifts.length > 1
    ) {

      for (
        var i = 1;
        i < gifts.length;
        i++
      ) {

        await removeGift(
          gifts[i]
        );

      }

    }

  }


  /*
   * ============================================
   * QUEUE SYNC
   * ============================================
   */

  function queueSync(
    delay
  ) {

    clearTimeout(
      state.syncTimer
    );


    state.syncTimer =
      setTimeout(
        function () {

          sync();

        },
        typeof delay ===
          'number'
          ? delay
          : CONFIG.syncDelay
      );

  }


  /*
   * ============================================
   * SYNC LOCK
   * ============================================
   */

  async function sync() {

    if (
      state.syncRunning
    ) {

      state.syncAgain =
        true;

      return;

    }


    state.syncRunning =
      true;


    try {

      do {

        state.syncAgain =
          false;

        await syncGift();

      } while (
        state.syncAgain
      );


    } catch (error) {

      console.error(
        '[Pomcha Free Gift ERROR]',
        error
      );


    } finally {

      state.syncRunning =
        false;


      if (
        state.syncAgain
      ) {

        state.syncAgain =
          false;

        queueSync(100);

      }

    }

  }


  /*
   * ============================================
   * PRELOAD GIFT
   * ============================================
   */

  loadGiftVariant(false)
    .catch(
      function (error) {

        console.error(
          '[Pomcha Free Gift] Gift preload failed:',
          error
        );

      }
    );


  /*
   * ============================================
   * THEME CART EVENTS
   * ============================================
   */

  [
    'cart:change',
    'line-item:change',
    'cart:refresh',
    'cart:updated'
  ].forEach(
    function (eventName) {

      document.addEventListener(
        eventName,
        function () {

          queueSync(150);

        }
      );

    }
  );


  /*
   * ============================================
   * PATCH FETCH
   * ============================================
   */

  if (
    !window.__pomchaFreeGiftFetchV6
  ) {

    window.__pomchaFreeGiftFetchV6 =
      true;


    var originalFetch =
      window.fetch;


    window.fetch =
      function () {

        var args =
          arguments;

        var requestUrl =
          '';


        try {

          if (
            typeof args[0] ===
            'string'
          ) {

            requestUrl =
              args[0];

          } else if (
            args[0] &&
            args[0].url
          ) {

            requestUrl =
              args[0].url;

          }

        } catch (e) {}


        var result =
          originalFetch.apply(
            this,
            args
          );


        if (
          requestUrl.indexOf(
            '/cart/add'
          ) !== -1 ||

          requestUrl.indexOf(
            '/cart/change'
          ) !== -1 ||

          requestUrl.indexOf(
            '/cart/update'
          ) !== -1 ||

          requestUrl.indexOf(
            '/cart/clear'
          ) !== -1
        ) {

          result.then(
            function () {

              queueSync(250);

            }
          ).catch(
            function () {}
          );

        }


        return result;

      };

  }


  /*
   * ============================================
   * INITIAL CHECK
   * ============================================
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        queueSync(300);

      },
      {
        once: true
      }
    );

  } else {

    queueSync(300);

  }


})();